<template>

    <div class="slider_container">
        <div class="slider_label">
            {{ currentLabel }}
        </div>
        <div class="slider_coeffs_container">

            <VueSlider
                ref="slider"
                height="12px"
                dot-size="16"
                :max="max"
                :min="0"
                :interval="10"
                :value="val"
                :disabled="disabled"
                @change="syncVal" />

            <div class="compare_coeffs_container">
                <div class="first_friend_compare" v-if="firstFriend">
                    <span class="friend_color first_color"></span>
                    <span class="friend_coeff first_coeff">{{ firstFriend.coeffs[coeffId] }}</span>
                </div>
                <div class="second_friend_compare" v-if="secondFriend">
                    <span class="friend_color second_color"></span>
                    <span class="friend_coeff second_coeff">{{ secondFriend.coeffs[coeffId] }}</span>
                </div>
            </div>
        </div>

        <div class="slider_value">
        {{ val }}
        </div>
    </div>

</template>

<script>
import s3SkillsLabels from '@/locales/s3SkillsLabels'

export default {
    name: 'CoeffSlider',
    props: ['coeffId', "refCoeff", "label", "disabled", 'firstFriend', 'secondFriend'],
    data(){
        return {
            labels: s3SkillsLabels
        }
    },
    computed: {
        currentLabel(){
            return this.label ? this.label : this.labels[this.$i18n.locale][this.coeffId]
        },
        val(){
            return this.refCoeff
        },
        max(){
            return this.coeffId == 'total' ? 500 : 100
        }
    },
    methods: {
        syncVal(newVal){
            this.$emit('change', {id: this.coeffId, val: newVal})
        }
    }
}

</script>

<style lang="scss">
.vue-slider{
    background: $grey-lighter;
    border-radius: 15px;
    padding: 3px!important;
}
.vue-slider-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.vue-slider-rail {
  background-color: $grey-lighter;
  border-radius: 15px;
}

.vue-slider-process {
  background-color: $primary;
  border-radius: 15px;
}

.vue-slider-mark {
  z-index: 4;
}
.vue-slider-mark:first-child .vue-slider-mark-step, .vue-slider-mark:last-child .vue-slider-mark-step {
  display: none;
}
.vue-slider-mark-step {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.16);
}
.vue-slider-mark-label {
  font-size: 14px;
  white-space: nowrap;
}
.vue-slider-dot{

}
.vue-slider-dot-handle {
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(0,0,0,0);
  box-sizing: border-box;
  box-shadow: none;
}
.vue-slider-dot-handle-focus {
  box-shadow: none;
}

.vue-slider-dot-handle-disabled {
  cursor: not-allowed;
  background-color: #ccc;
}

.vue-slider-dot-tooltip-inner {
  font-size: 14px;
  white-space: nowrap;
  padding: 2px 5px;
  min-width: 20px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  border-color: $primary;
  background-color: $primary;
  box-sizing: content-box;
}
.vue-slider-dot-tooltip-inner::after {
  content: "";
  position: absolute;
}
.vue-slider-dot-tooltip-inner-top::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  height: 0;
  width: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-top-color: inherit;
}
.vue-slider-dot-tooltip-inner-bottom::after {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  height: 0;
  width: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-bottom-color: inherit;
}
.vue-slider-dot-tooltip-inner-left::after {
  left: 100%;
  top: 50%;
  transform: translate(0, -50%);
  height: 0;
  width: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-left-color: inherit;
}
.vue-slider-dot-tooltip-inner-right::after {
  right: 100%;
  top: 50%;
  transform: translate(0, -50%);
  height: 0;
  width: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-right-color: inherit;
}

.vue-slider-dot-tooltip-wrapper {
  opacity: 0;
  transition: all 0.3s;
}
.vue-slider-dot-tooltip-wrapper-show {
  opacity: 1;
}

//Coeff slider specific
.slider_container{
    display: flex;
    .vue-slider{
        flex: 1;
    }
}
.valid .slider_container .vue-slider-process {
    background-color: $success;
}
.up .slider_container {
  .vue-slider{
      background-color: $danger;
      .vue-slider-rail {
          background-color: $danger;
      }
  }
  .slider_value{
    color: $danger;
  }
}
.down .slider_container .vue-slider-process {
    background-color: $info;
}
.slider_container{
    display: flex;
    height: 60px;
    .slider_label{
        flex: 1;
        text-align: right;
        padding-right: 12px;
        margin-right: 12px;
        // border-right: 1px solid $grey-light;
    }
    .slider_coeffs_container{
        flex: 1;
        max-width: 200px;
        .vue-slider{

            cursor: pointer;
        }
        .compare_coeffs_container{
            display: flex;
            margin-top:8px;
            .friend_color{
                display: block;
                height: 16px;
                width: 16px;
                background-color: $primary;
                border-radius: 100%;
                margin-right: 8px;
            }
            .friend_coeff{
                font-weight: 500;
            }
            .first_friend_compare, .second_friend_compare{
                display: flex;
                margin-right: 15px;
                width: 50px;
            }
            .first_color{
                background-color: $second-score-color;
            }
            .second_color{
                background-color: $third-score-color;
            }
        }

    }
    .slider_value{
        width: 50px;
        text-align: right;
        font-weight: 600;
    }
    .vue-slider-disabled {
        opacity: 1;
    }
}
.total_slider_container{
    margin: 25px 0px 63px;
    .slider_container{
        height: auto;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .slider_label{
            width: 100%;
            min-width: 100%;
            text-align: center;
            border: none;
            padding: 0;
            margin: 0;
            font-weight: 600;
            font-size: 1.2rem;
        }
        .slider_coeffs_container{
                max-width: 80%;
                min-width: 80%;
                height: 16px!important;
            .vue-slider{
            }
        }
        .slider_value{
            max-width: 20%;
            min-width: 20%;
            font-weight: 600;
            font-size: 1.2rem;
            text-align: center;
        }
    }
}
</style>










































